/* eslint-disable react-hooks/exhaustive-deps */
import { B000010Auth, B000011Valid, B000020Find } from "clients/rest";
import { ReactNode, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import { authState, getAuth, getMenus, menusState } from "states";

type Props = {
  children: ReactNode;
};

export const AuthRoute = (props: Props) => {
  const [auth, setAuth] = useRecoilState(authState);
  const setMenus = useSetRecoilState(menusState);
  const navigate = useNavigate();

  const [children, setChildren] = useState<ReactNode>(<></>);

  // 初期処理
  useEffect(() => {
    // 認証情報が存在しない場合、認証情報を取得する。
    if (typeof auth !== "undefined") {
      setChildren(props.children);
      return;
    }
    B000010Auth()
      .then((value) => {
        // 認証済みの場合、認証情報を設定する。
        setAuth(getAuth(value.data));
        const kengenId = value.data.kengenId;
        B000011Valid()
          .then(() => {
            // 権限定義一覧を取得する。
            B000020Find({ kengenId: kengenId })
              .then((value) => {
                setMenus(getMenus(value.data));
                setChildren(props.children);
              })
              .catch((reason) => {
                // 取得できない場合、ログイン画面へ遷移する。
                navigate("/b000010");
              });
          })
          .catch(() => {
            // 端末が未認証の場合、端末認証画面へ遷移する。
            navigate("/b000011");
          });
      })
      .catch((reason) => {
        // 未認証の場合、ログイン画面へ遷移する。
        navigate("/b000010");
      });
  });
  return <>{children}</>;
};
